import { RootState } from '@Redux/store'
import { createSelector } from '@reduxjs/toolkit'

export const configMarkets = (state: RootState) => state.config.markets
export const selectMarketByCurrencies = createSelector(
  configMarkets,
  (_: RootState, sourceCurrency: string, targetCurrency: string) => ({
    sourceCurrency,
    targetCurrency,
  }),
  (markets, { sourceCurrency, targetCurrency }) => {
    return markets.find(
      (m) =>
        m.source_currency === sourceCurrency &&
        m.target_currency === targetCurrency
    )
  }
)

export const selectKlinesForMarket = createSelector(
  [configMarkets, (_: RootState, marketId: number) => marketId],
  (markets, marketId) => {
    const market = markets.find(m => m.id === marketId);
    return market?.klines || null;
  }
);

export const configFavoriteMarkets = (state: RootState) => state.config.favoriteMarkets
export const configActiveFavoriteMarket = (state: RootState) => state.config.activeFavoriteMarket
export const configHistoryFeeds = (state: RootState) => state.config.history_feeds